import React from "react";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {logout} from "./Redux/actions/user";
class Head extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user.user,
      open: false,
    };
  }
  render() {
    return (
      <header className="header-area formobile-menu header--transparent black-logo-version header--sticky">
        <div
          className={
            this.state.open ? "header-wrapper menu-open" : "header-wrapper"
          }
          id="header-wrapper">
          <div className="header-left">
            <div className="logo">
              <Link
                to="/"
                style={{textDecoration: "none"}}
                onClick={() => this.setState({open: false})}>
                <h2 style={{fontSize: 30, color: "#aaa", fontWeight: "bolder"}}>
                  V.I.L.A.J
                </h2>
              </Link>
            </div>
          </div>
          <div className="header-right">
            <nav className="mainmenunav d-lg-block navbar-example2">
              {/*  Start Mainmanu Nav */}
              <ul className="mainmenu nav nav-pills">
                <li
                  className="nav-item"
                  onClick={() => this.setState({open: false})}>
                  <Link
                    className="nav-link "
                    to="/"
                    style={{textDecoration: "none"}}>
                    Acceuil
                  </Link>
                </li>
                {this.state.user &&
                this.state.user.user &&
                this.state.user.user.role_user === "admin" ? (
                  <li
                    className="nav-item"
                    onClick={() => this.setState({open: false})}>
                    <Link
                      className="nav-link "
                      to="/dashboard"
                      style={{textDecoration: "none"}}>
                      dashboard
                    </Link>
                  </li>
                ) : null}
                <li
                  className="nav-item"
                  onClick={() => this.setState({open: false})}>
                  <Link
                    className="nav-link "
                    to="/market"
                    style={{textDecoration: "none"}}>
                    Vilaj Market
                  </Link>
                </li>

                {/* <li className="nav-item">
                  <a className="nav-link smoth-animation" href="#blog">
                    Blog
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link smoth-animation" href="#contact">
                    Contactez-nous
                  </a>
                </li> */}
              </ul>
              {/*  End Mainmanu Nav */}
            </nav>
            <div className="header-btn">
              {this.state.user == null ? (
                <button
                  className="rn-btn"
                  data-toggle="modal"
                  data-target="#loginModal"
                  data-whatever="@getbootstrap">
                  <span>Compte</span>
                </button>
              ) : (
                <button
                  className="rn-btn"
                  onClick={() => {
                    this.props.logout();
                    window.location.reload();
                  }}>
                  <span>Decon.</span>
                </button>
              )}
            </div>
            {/*  Start Humberger Menu  */}
            <div className="humberger-menu d-block d-lg-none pl--20">
              <span
                className="menutrigger text-white"
                onClick={() => this.setState({open: !this.state.open})}>
                <i data-feather="menu">
                  <img src="/menu.png" />
                </i>
              </span>
            </div>
            {/*  End Humberger Menu  */}
            {/*  Start Close Menu  */}
            <div className="close-menu d-block d-lg-none">
              <span
                className="closeTrigger"
                onClick={() => this.setState({open: !this.state.open})}>
                <i data-feather="x">
                  {" "}
                  <img src="/close.png" width={30} />
                </i>
              </span>
            </div>
            {/*  End Close Menu  */}
          </div>
        </div>
      </header>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => {
      dispatch(logout());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Head);
